<div>
  <table class="wide-tooltip">
    <tr *ngFor="let alarm of alarmList">
      <td class="gridDetail">
        <span><img style="width: 16px; height: 16px;" src="{{alarm.icon}}" />&nbsp;{{alarm.status}}</span>
      </td>
    </tr>

  </table>
</div>
